import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';
import { stepperAction } from '../../../../application/actions/stepper';
import { Wrapper } from './styles';
import { properties } from '../../../../utils/properties'

import iconcedula from '../../../assets/img/icon/icon-cedula.svg';
import iconprevisional from '../../../assets/img/icon/icon-previsional.svg';
import iconliquidacion from '../../../assets/img/icon/icon-liquidacion.svg';



const DocumentoSucursalTemplate = ({ activeMenu }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(stepperAction.fetchStepper(activeMenu));
  }, [activeMenu]); return (
    <Wrapper>


      <form>
        <Card>
          <CardTitlePrimary
            title={properties.solicitudFinalizada.documentosSucursal.titulo}
          />
          <CardContent>
            <div className="contenedor">
              <div className="info">
                <img className="iconcedula" src={iconcedula} alt="cedula" />
                <p className="p-mensaje">{properties.comprobante.cedula.titulo}</p>
                <p className="p-coment">
                  {properties.comprobante.cedula.subtitulo}
                </p>
              </div>
              <div className="info">
                <img className="iconliquidacion" src={iconliquidacion} alt="liquidacion" />
                <p className="p-mensaje">{properties.comprobante.cotizaciones.titulo}</p>
                <p className="p-coment">
                  {properties.comprobante.cotizaciones.subtitulo}
                </p>
              </div>
              <div className="info">
                <img className="iconprevision" src={iconprevisional} alt="prevision" />
                <p className="p-mensaje">{properties.comprobante.liquidaciones.titulo}</p>
                <p className="p-coment">{properties.comprobante.liquidaciones.subtitulo}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </form>

    </Wrapper>
  )
}
DocumentoSucursalTemplate.propTypes = {
  activeMenu: PropTypes.number,

};
DocumentoSucursalTemplate.defaultProps = ({
  activeMenu: 5
});

export default DocumentoSucursalTemplate;